import React, { useState } from "react";
import { ReactComponent as EditIcon } from "../../assets/edit-profile.svg";
import { ReactComponent as FilledUserIcon } from "../../assets/fill-user.svg";
import { ReactComponent as UserIcon } from "../../assets/outline-user.svg";
import { ReactComponent as LockIcon } from "../../assets/lock 01.svg";
import { ReactComponent as FilledLockIcon } from "../../assets/fill-lock.svg";
import ProfileDetails from "./components/ProfileDetails";
import Password from "./components/Password";
import { useUser } from "../../context/UserContext";
const Settings = () => {
  const [active, setActive] = useState("profile");
  const { user } = useUser();
  console.log(user);

  const setActiveTab = (tab) => {
    setActive(tab);
  };
  return (
    <div>
      <div className="w-full rounded-bl-lg rounded-br-lg bg-gradient-to-t   from-[#2E3E8D] to-[#4DB1E1] py-2.5 min-h-[145px] flex items-center justify-center px-4">
        <div className="bg-setting-gradient py-2.5 w-full min-h-[113px] rounded-[15px] backdrop-blur-[30px] flex items-center flex-wrap justify-between px-4 gap-4">
          <div className="flex flex-wrap items-center  gap-4">
            <div className="relative">
              <img
                src="https://www.gravatar.com/avatar/2c7d99fe281ecd3bcd65ab915bac6dd5?s=250"
                alt=""
                className="w-[81px] h-[81px] rounded-[12px]"
              />
              <div className="bg-white rounded-[8px] flex items-center justify-center absolute -bottom-2 w-[26px] h-[26px] -right-2">
                <EditIcon />
              </div>
            </div>
            <div>
              <h1 className="text-white font-semibold text-xl">
                {user?.username}
              </h1>
              <h5 className="text-white text-sm">{user?.emailId}</h5>
            </div>
          </div>
          <h6 className="text-sm text-white">
            {user?.userType === 1 ? "Corporate" : "Individual"}
          </h6>
        </div>
      </div>

      <div className="w-full bg-white min-h-[716px] rounded-[10px] my-4">
        <div className="w-full py-4">
          <div className="flex items-center justify-between xs:justify-start px-2 xs:px-4 gap-3 border-b border-b-[#EEF2F6]">
            <div
              onClick={() => setActiveTab("profile")}
              className="flex items-center gap-2 h-12 px-2 overflow-hidden relative hover:cursor-pointer"
            >
              {active === "profile" ? <FilledUserIcon /> : <UserIcon />}
              <h1
                className={`${
                  active === "profile" ? "text-[#306BFF]" : "text-[#94A3B8]"
                } font-semibold`}
              >
                Profile Details
              </h1>
              {active === "profile" && (
                <span className="w-full absolute bottom-[-1px]  h-[4px] bg-[#306BFF] rounded-full "></span>
              )}
            </div>
            <div
              onClick={() => setActiveTab("password")}
              className="hover:cursor-pointer flex items-center gap-2 h-12 px-2 overflow-hidden relative"
            >
              {active === "password" ? <FilledLockIcon /> : <LockIcon />}
              <h2
                className={`${
                  active === "password" ? "text-[#306BFF]" : "text-[#94A3B8]"
                } font-semibold`}
              >
                Password
              </h2>
              {active === "password" && (
                <span className="w-full absolute bottom-[-1px]  h-[4px] bg-[#306BFF] rounded-full "></span>
              )}
            </div>
          </div>
        </div>

        {active === "profile" && <ProfileDetails />}
        {active === "password" && <Password />}
      </div>
    </div>
  );
};

export default Settings;
